/* this file added by Bearer Web Developer  */
import React, { useRef } from 'react';
import { TextFieldProps } from '@mui/material';
import styles from './BearerDateField.module.scss'; // added by Bearer Web Developer
type IColorStyle = "blue" | "gray" | "white";
type BearerTextFieldProps = TextFieldProps & { validator?: (value: string) => string | undefined }
    & { colorStyle?: IColorStyle } & { clear?: () => void } // extended by Bearer Web Developer
    & { inputSmallStyle?: boolean } & { withoutLabel?: boolean }; // extended by Bearer Web Developer
// inputProperties interface added by Bearer Web Developer
interface inputProperties {
    label?: string
    value?: string
    onChange?: () => {}
    onClick?: () => {}
    disabled?: boolean
    placeholder?: string
    name?: string
}
const BearerDateField: React.FC<BearerTextFieldProps> = ({ validator, withoutLabel, inputSmallStyle, colorStyle, clear, ...props }) => {
    const [touched, setTouched] = React.useState(false);
    const [error, setError] = React.useState({ value: null as null | string, error: false, helperText: '' }); // value: '' changed to value: null as null for not showing empty value errors by Bearer Web Developer
    const inputRef = useRef<HTMLInputElement | null>(null);
    React.useEffect(() => {

        if (validator) { // validator && props.value  changed to validator for not showing empty value errors by Bearer Web Developer
            const value = props.value as string;
            if (error.value !== value) {
                const helperText = validator(value);
                if (helperText) {
                    setError({ value, error: true, helperText });
                } else {
                    if (error.error) {
                        setError({ value, error: false, helperText: '' });
                    }
                }
            }
        }
    }, [validator, props.value, touched, error, setError])

    const handleFocus = () => {
        setTouched(true);
    }
    // added by Bearer Web Developer start
    const handleCloseClear = () => {
        if (clear) {
            clear();
        }
    }
    const subtractEighteenYears = () => {
        const date = new Date();
        const year = String(date.getFullYear() - 18);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const closeClearSrc = colorStyle === "gray" ? "/close-clear-white.svg" : colorStyle === "white" ? "/close-clear-black.svg" : "/close-clear-blue.svg";
    // added by Bearer Web Developer end
    // modified by Bearer Web Developer start
    const { inputProps, label, name, placeholder, ...otherProps } = props;
    return (
        <div className={otherProps.disabled ? `${styles.disabled} ${styles.text_input}` : styles.text_input}>
            <div className={`${colorStyle ? styles?.[colorStyle] : styles.blue}`}>
                {
                    !withoutLabel &&
                    <div className={styles.label}>
                        <label htmlFor={name || label?.toString()}>{label}</label>
                    </div>
                }
                <div className={`${styles.input_part} ${inputSmallStyle ? styles.input_small : ''}`}>
                    <input {...inputProps} name={name || label?.toString()} type='date' ref={inputRef}
                        id={name || label?.toString()} max={subtractEighteenYears()}
                        {...otherProps as inputProperties} onFocus={handleFocus} placeholder={placeholder} />
                    <>
                        {/* close clear button added by Bearer Web Developer   */}
                        {
                            props.value &&
                            <img className={styles.close_clear}
                                src={closeClearSrc}
                                alt="" width={24} height={24}
                                onClick={handleCloseClear}
                            />
                        }
                    </>
                    <img className={styles.vector} src={`/vector-grey.webp`} alt="" width={20} height={20}
                        onClick={() => { if (inputRef) (inputRef?.current)?.showPicker() }}
                    />
                </div>
                {error.error &&
                    <div className={styles.error}>
                        <img src="/error-red.png" alt="" />
                        <div className={!colorStyle || (colorStyle && colorStyle === "blue") ? styles.error_blue : ''}>
                            {error.helperText}
                        </div>
                    </div>}
            </div>
        </div>
    );
    // modified by Bearer Web Developer end
}
export default BearerDateField;